import { ActivityIndicator, Dimensions, FlatList, Image, Modal, PixelRatio, ScrollView, StyleSheet, Text, View } from 'react-native'
import React, { useEffect, useState } from 'react'
import Colours from '../../utils/Colours'
import { TouchableOpacity } from 'react-native'
import Toast from 'react-native-toast-message'
import toastConfig from '../../toasts/toastConfig'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'
//import toastConfig from '../../toasts/toastConfig'


const { width, height } = Dimensions.get('window');
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
    const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
    const newSize = size * scaleFactor;

    return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const CelebratoriesNotification = ({ notificationData }) => {

    const [isLoading, setIsLoading] = useState(false)

    const axiosPrivate = useAxiosPrivate()


    const celebratories = notificationData?.filter(
        (n) => n.type === "celebratory"
    ) || [];

    useEffect(() => {

        const markAllCelebratoryNotificationAsRead = async () => {
            setIsLoading(true)
            try {

                const response = await axiosPrivate.post('/markCelebratorySeen/markCelebratorySeen')

                if (response.status === 200 || response.status === 201) {

                    //console.log('marked status: All Notifications Read')

                }

            } catch (error) {
                //console.log('Error Notification DatA', error)
            } finally {
                setIsLoading(false)

            }

        }
        markAllCelebratoryNotificationAsRead()
    }, [])

    const handleShowCelebratories = () => {
        Toast.show({
            type: 'success',
            text1: 'Click on Pulls',
            text2: 'Navigate to Pulls to see all celebratory gifts.',
            // position: 'bottom',
            visibilityTime: 2000,
        });
    }


    if (isLoading) {
        return (
            <View style={{ flex: 1, alignItems: 'center' }}>
                <ActivityIndicator size={'large'} color={Colours.PRIMARY} />
            </View>
        )
    }

    return (
        <View>
            <ScrollView
                style={styles.componentStyle}
                contentContainerStyle={{ flexGrow: 1, paddingBottom: 100 }}
                showsVerticalScrollIndicator={false}
            >
                <View style={styles.notificationItemsStyle}>



                    <FlatList
                        data={celebratories}
                        scrollEnabled={false}
                        renderItem={({ item: celebrate }) => (
                            <TouchableOpacity style={styles.profileContainer}
                                onPress={handleShowCelebratories}>
                                {celebrate.sender.profilePicture ? (<Image source={{ uri: celebrate?.sender.profilePicture }} style={styles.userImage} />
                                ) : (
                                    <Image source={require('../../../assets/profile_image_holder.jpg')} style={styles.userImage} />
                                )}
                                <View >
                                    <Text style={{ color: Colours.DARKGRAY, fontSize: 15, fontFamily: 'Sen-Regular', width: 260 }}>{celebrate?.message}</Text>
                                </View>
                            </TouchableOpacity>)
                        } />

                </View>
            </ScrollView>


            <Toast config={toastConfig} />

        </View>
    )
}

const styles = StyleSheet.create({
    componentStyle: {
        backgroundColor: Colours.LIGHTEST,
        height: '100%',
    },
    // notificationItemsStyle: {
    //     display: 'flex',
    //     backgroundColor: 'white',
    //     margin: 15,
    //     padding: 10,
    //     borderRadius: 15,

    // },
    profileContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        margin: dynamicSpacing(15),
        marginBottom: 0,
        padding: dynamicSpacing(15),
        backgroundColor: 'white',
        borderRadius: dynamicSize(15),

        gap: dynamicSpacing(10),
    },
    userImage: {
        width: dynamicSize(45),
        height: dynamicSize(45),
        borderRadius: dynamicSize(99),

    }
})

export default CelebratoriesNotification
